export default {
  state: {
    hasValidJWT: true,
  },

  mutations: {
    SET_JWT_TOKEN_VALIDITY (state, isValid) {
      state.hasValidJWT = isValid
    },
  },

  actions: {
    setJwtTokenValidity ({ commit }, isValid) {
      commit('SET_JWT_TOKEN_VALIDITY', isValid)
    },
  },
}
